import MemberProfileInsights from '@commons/pagebuilder/nodes/Member/Profile/Insights';
import { INSIGHTS_VIEW_DISPLAY } from '@commons/pagebuilder/views/Insights';

import { AIIA_VIEW_TYPE } from '@/pagebuilder/views';

/**
 * Type definition of the AiiA member profile insights component properties.
 */

type Props = {
  id: number;
};

/**
 * AiiA - MemberProfileInsights component.
 *
 * Fetches and renders a set of insights based on the member id.
 */

const AiiA_MemberProfileInsights = ({ id }: Props) => (
  <MemberProfileInsights
    id={id}
    viewId={AIIA_VIEW_TYPE.Insights}
    display={INSIGHTS_VIEW_DISPLAY.ByMember}
  />
);

export default AiiA_MemberProfileInsights;
